import { Component, OnInit } from '@angular/core';
import { StorafeUtil } from '../../shared/util/storasge.util';
import { CODIGO_CENTRUS } from '../../../app.constants';
import { EnderecoCadastroService } from '../../shared/services/endereco-cadastro.service';

@Component({
  selector: 'app-painel-avaliacao-risco',
  templateUrl: './painel-avaliacao-risco.component.html',
  styleUrls: ['./painel-avaliacao-risco.component.css']
})
export class PainelAvaliacaoRiscoComponent implements OnInit {

  constructor(
    private enderecoCadastroService: EnderecoCadastroService, // Replace with actual service type
  ) { }

  urlRelatorio: string = '';

  param = '/cardMenus/cardMenuAdministrativo';

  ngOnInit() {
    this.abrirRelatorio();
    
  }

  getDadosSesseionStorage(): Promise<string> {
        return new Promise((resolve, reject) => {
            const recuperandoObjeto =
                StorafeUtil.recuperarSessionStorage(CODIGO_CENTRUS);
            resolve(recuperandoObjeto);
        });
    }

    abrirRelatorio() {
        this.enderecoCadastroService.getToken().then((tokenObj: any) => {
            this.enderecoCadastroService.redirecionarParaRelatorio(tokenObj.id_token)
               .subscribe((url) => {
                window.open(url, '_blank');
            });
        });

        setTimeout(() => {
      window.history.back();
    }, 2000);
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/administrativo/painel-avaliacao-risco/painel-avaliacao-risco.component.ts